module.exports = __webpack_public_path__ + "img/lhv2DA.7f7fe33a.png";